import React from "react";
import classes from "./VerifyYourEmail.module.css";
import { checkEmailImg } from "images";
import { Button, Heading, Text } from "components/common";
const VerifyYourEmail = () => {
  return (
    <div className={classes.wrapper}>
      <img src={checkEmailImg} alt="#" className={classes.img} />
      <div className={classes.infoContainer}>
        <Heading xl3 font600 textCenter>
          Registration Successful
        </Heading>
        <Text lg primitive700 textCenter>
          Your registration was completed successfully
        </Text>
      </div>
      <Button to="/login">Proceed to Login</Button>
    </div>
  );
};

export default VerifyYourEmail;
